import update from 'immutability-helper';

export function deepOp(path, op) {
  if (path.length < 1) {
    return op;
  }
  const [current, ...rest] = path;
  return { [current]: deepOp(rest, op) };
}

export default function cursor(data, path, callback, missing) {
  const value = path.reduce((node, key) => node[key], data);
  return {
    value: value !== undefined ? value : missing,
    requestChange(value, shouldUpdateValue = true, silent = false) {
      const newValue = update(data, deepOp(path, { $set: value }));
      if (this && this.value) {
        this.value = shouldUpdateValue ? newValue : this.value;
      }
      if (!silent) {
        callback(newValue);
      }
    },
    sub(subPath, missing, subCallback) {
      return cursor(
        data,
        path.concat(subPath),
        subCallback || callback,
        missing,
      );
    },
  };
}
